'use strict';

angular.module('TurneroApp').component('coEncuestasWizard', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
    },
    controller: [
        'TurneroAppConstant',
        function (TurneroAppConstant) {
            var ctrl = this;

            ctrl.acciones = TurneroAppConstant.Acciones;
            ctrl.accion = null;
            ctrl.paso = null;
            ctrl.encuesta = null;

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadWizard = function (pAccion, item) {
                    ctrl.accion = pAccion;
                    ctrl.encuesta = item;

                    ctrl.switchTab(1);

                    if (ctrl.accion == ctrl.acciones.Crear) {
                        ctrl.titulo = 'Crear';
                    }
                    else if (item && item.Id_Encuesta) {
                        ctrl.titulo = ctrl.accion == ctrl.acciones.Ver ? 'Visualizar' : 'Editar';
                    }
                }
            }

            ctrl.switchTab = function (paso) {
                ctrl.paso = paso;

                if (paso == 1)
                    ctrl.tLoadPreguntas(ctrl.accion, ctrl.encuesta);
                else if (paso == 2)
                    ctrl.tLoadOpciones(ctrl.accion, ctrl.encuesta);
                //else if (paso == 3)
                     //ctrl.tLoadDisenio(ctrl.accion, ctrl.encuesta);
                else {
                    ctrl.paso = null;
                    ctrl.ctrlPadre.grillaReload();
                }
            }

            ctrl.nextTab = function () {
                ctrl.switchTab(ctrl.paso + 1);
            }

            ctrl.guardar = function () {
                //let sinErrores = true;

                if (ctrl.accion == ctrl.acciones.Ver) {
                    ctrl.nextTab();
                }
                else {
                    if (ctrl.paso == 1) {
                        ctrl.guardarPreguntas();
                    }
                    else if (ctrl.paso == 2) {
                        ctrl.guardarOpciones();
                    }
                    /*else if (ctrl.paso == 3) {
                        //ctrl.guardarDisenio();
                    }*/
                }
            }

            ctrl.cancelar = function () {
                ctrl.paso = null;
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./encuestasWizard.html')
});



// WEBPACK FOOTER //
// ./app/components/supervision/encuestas/encuestasWizardComponent.js